module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9DPLo"))).then(() => parcelRequire('7rUq7'));